module.exports = __webpack_public_path__ + "static/media/8500.2b83336b.jpg";